import React from "react";
import { Radar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  Title,
  TimeScale,
  BarElement
} from "chart.js";
import "chartjs-adapter-date-fns"; // Adapter for time-based scales


let isChartRegistered = false;



const StyledRadarChart = ({ stats = {}, height=400, width=400 }) => {

  const getGrade = (value) => {
    if (value < 0 || value > 100) {
      throw new Error('Value must be between 0 and 100');
    }
  
    const grades = [
      { grade: 'S', color: '#FFD700', min: 95 }, // Gold
      { grade: 'A', color: '#00FF00', min: 80 }, // Green
      { grade: 'B', color: '#007BFF', min: 65 }, // Blue
      { grade: 'C', color: '#FFA500', min: 50 }, // Orange
      { grade: 'D', color: '#FF4500', min: 35 }, // Red
      { grade: 'E', color: '#FF0000', min: 5 }, // Dark red
      { grade: 'F', color: '#800000', min: 0 }, // Maroon
    ];
  
    for (const { grade, color, min } of grades) {
      if (value >= min) {
        return { grade, color };
      }
    }
  };
  
  const GradePlugin = {
    id: 'grade_plugin',
    afterDraw: (chart) => {
      if (chart.config.type !== "radar") {
        return;
      }


      const ctx = chart.ctx;
      const { labels } = chart.data;
      const scale = chart.scales.r; // Use the radial scale
      const radius = scale.width / 2; // Get the radius of the chart
  
      // Loop through each label to draw the grade
      labels.forEach((label, index) => {
        const value = chart.data.datasets[0].data[index]; // Get the corresponding value from the dataset
        const { grade, color } = getGrade(value); // Get grade and color based on value
  
       // Calculate the position for the grade letter below the label
       const angle = scale.getPointPosition(index, radius * 1.25); // Get position on the chart
       const x = angle.x;
       const y = angle.y - 10; // Adjust y position slightly to place the grade below the label
  
       ctx.font = "12px FolkProH";
       ctx.fillStyle = "#ccdffc"; // Apply the grade's color
       ctx.textAlign = "center"; // Center the text horizontally
       ctx.textBaseline = "middle"; // Center the text vertically
       ctx.lineWidth = 2; // Thickness of the outline
       ctx.strokeStyle = "#123f52"; // Color of the outline (black)
  
       ctx.fillText(label, x, y+19);
  
       ctx.fillStyle = color; // Apply the grade's color
       // Apply the outline using strokeText
       ctx.lineWidth = 1; // Thickness of the outline
       ctx.strokeStyle = "#FFFFFF";
       ctx.font = "bold 14px FolkProH";
       ctx.fillText(grade, x, y);
       //ctx.strokeText(grade, x, y);
  
  
      });
    },
  };
  
  if (!isChartRegistered) {
    ChartJS.register(
      RadialLinearScale,
      PointElement,
      LineElement,
      CategoryScale,
      LinearScale,
      Title,
      Filler,
      Tooltip,
      Legend,
      GradePlugin,
      TimeScale,
      BarElement
    );
    isChartRegistered = true; // Prevent further registrations
  }

  const data = {
    labels: Object.keys(stats), // Custom labels
    datasets: [
      {
        label: "Bot Performance",
        data: Object.values(stats), // Replace with your dynamic data
        backgroundColor: "rgba(72, 126, 176, 0.35)", // Blue fill with transparency
        borderColor: "#4ba7de", // Solid blue border
        borderWidth: 1,
        pointBackgroundColor: "#FFFFFF00", // White points
        pointBorderColor: "#487EB000",
        pointRadius: 2,
        pointHoverRadius: 2,

      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: {
        top: 0, // Adjust top padding
        bottom: 0, // Adjust bottom padding
        left: 75, // Adjust left padding
        right: 75, // Adjust right padding
      },
    },
    scales: {
      r: {
        min: 0,
        max: 100,
        beginAtZero: true,
        stepSize: 10,
        angleLines: {
          lineWidth: 1,
          display: true,
          color: "#123f52", // Dark gray angle lines
        },
        grid: {
          display: true,
          lineWidth: 1,
          color: (context) => {
            return context.index === context.chart.scales.r.ticks.length - 1
              ? "#5bb7de" // Outer grid line color
              : "transparent"; // Hide inner grid lines
          }
        },
        pointLabels: {
          display: false,
        },
        ticks: {
          display: false, // Hide ticks (A, B, C, etc., will be custom)
          beginAtZero: true,
          max: 100,
          min: 0,
          stepSize: 10
        },
      },
    },
    plugins: {
      legend: {
        display: false, // Hide default legend
      },
      tooltip: {
        enabled: false,
      },
    },
  };

  return (
      <div className="w-full" style={{width:`${width}px`, height: `${height}px` }}>
        <Radar data={data} options={options} />
      </div>
  );
};

export default StyledRadarChart;
